<template>
    <a class="trans-btn" :href="url" target="_blank">
        <div class="d-flex justify-content-center align-items-center flex-column">
            <div class="icon-container">
                <!-- Main Icon -->
                <div class="icon main-icon" :style="backgroundStyle">
                    <i :class="icon"></i>
                </div>
                <!-- Hover Icon -->
                <div class="icon hover-icon" :style="hoverColorStyle">
                    <i :class="icon"></i>
                </div>
            </div>
            <span class="icon-text">{{ title }}</span>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        backgroundColor: {
            type: String,
            required: true
        },
        hoverColor: {
            type: String,
            required: false
        }
    },

    computed: {
        backgroundStyle() {
            return {
                'background-color': this.backgroundColor
            };
        },
        hoverColorStyle() {
            return {
                'background-color': this.hoverColor
            };
        }
    }
};


</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');
/* 
Font Awesome for the Facebook icon */

a {
    text-decoration: none;
    color: rgba(255, 255, 255, .75);
}

a:hover {
    text-decoration: none;
    color: rgba(255, 255, 255, .75);
}

.icon-text {
    margin-top: 5px;
    /* Adds some space between the icon and the text */
    font-size: 12px;
}

.icon-container {
    position: relative;
    width: 40px;
    /* Size of the circle */
    height: 40px;
    border-radius: 50%;
    /* Makes it round */
    overflow: hidden;
    /* Ensures child elements stay within bounds */
    background-color: transparent;
    /* Optional background for the container */
}

.icon {
    position: absolute;
    width: 40px;
    /* Size of the circle */
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    /* Icon color */
    transition: transform 0.3s ease;
    /* Smooth animation */
}

.main-icon {
    transform: translateY(0);
    /* Initial position: fully visible */
    background-color: #3b5998;
    /* Facebook blue background for the main icon */
}

.hover-icon {
    transform: translateY(-100%);
    /* Initial position: above the container */
    background-color: #1a3e72;
    /* A darker shade for the hover state */
}

.icon-container:hover .main-icon {
    transform: translateY(100%);
    /* Moves down out of view */
}

.icon-container:hover .hover-icon {
    transform: translateY(0);
    /* Slides into view */
}
</style>